<template>
  <v-dialog v-model="dialog" persistent content-class="consulting-template-dialog" :max-width="dialogWidth">
    <div class="layerPopup large">
      <div class="layerTit">
        <span class="smTxt">{{ dialogContent.subTitle }}</span>
        <span class="text-overflow">{{ dialogContent.title }}</span>
      </div>
      <div class="layerContent large">
        <div :key="classes"
          :class="classes">
          <vue-perfect-scrollbar
              class="dialog-scroll"
              :class="{ 'mail' : dialogContentType === 'MAIL',
              'etc': dialogContentType !== 'MAIL',
               'img': dialogContentType === 'IMAGE' }"
              tagname="div">
            <div
              v-if="dialogContentType === 'MAIL'"
              v-html="dialogContent.content"
            >
            </div>
            <div
              v-else-if="dialogContentType === 'IMAGE'"
            >
              <v-img
                :contain="true"
                :src="dialogContent.content"
              />
            </div>
            <div
              v-else
              style="white-space: pre-line"
              v-html="dialogContent.content"
            ></div>
          </vue-perfect-scrollbar>
        </div>
      </div>
      <div class="layerClose">
        <v-btn flat icon @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: 'consultingTemplateDialog',
  props: {
    dialog: {
      type: Boolean,
      required: true
    },
    dialogContent: {
      type: Object,
      required: true
    },
    dialogContentType: {
      type: String,
      required: true
    },
    dialogWidth: {
      type: [Number, String],
      required: true
    }
  },
  computed: {
    classes () {
      let classes = 'dialog-content'
      if (this.dialogContentType === 'IMAGE') {
        classes = `${classes} img`
      } else if (this.dialogContentType === 'MAIL') {
        classes = `${classes} mail`
      } else {
        classes = `${classes} etc`
      }
      return classes
    }
  }
}
</script>

<style scoped lang="scss">
.consulting-template-dialog {
  .layerPopup {
    min-height: 740px;
    > .layerTit {
      .smTxt {
        display: block;
        padding-left: 0;
        margin-bottom: 6px;
      }
      .text-overflow {
        vertical-align: bottom;
        display: -webkit-box;
        max-width: 660px;
        max-height: 54px;
        overflow:hidden;
        white-space: normal;
        text-overflow: ellipsis;
        line-height: 27px;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical
      }
    }

    > .layerClose {
      top: 37px;
    }
  }

  .dialog-content {
    padding: 20px 0px 20px 20px !important;
    max-width: 700px;
    border: 1px solid #E8E8E8;
    box-sizing: border-box;
    border-radius: 5px;
    color: #000000;

    &.img {
      border: 1px solid transparent !important;
      border-radius: 0px !important;
      padding: 0px !important;
    }

    .dialog-scroll {
      padding-right: 25px;
      min-height: 570px;
      &.img {
        padding-right: 0px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/agent/components/consultingTemplateDialog.vue